<div *ngIf="data.size" [ngClass]="{ 'is-loading': isLoading }">
  <h4>
    <span translationEditableDirective="CALCULATION_PREVIEW">{{
      'CALCULATION_PREVIEW' | translate
    }}</span>
  </h4>
  <property-invoice-item
    *ngFor="let calculation of data"
    [data]="calculation"
    [activeForm]="activeForm"
    [propertyDetails]="propertyDetails"
    (onReport)="onReport.emit($event)"
    [isPropertyReportGenerating]="isPropertyReportGenerating"
    [dynamicFieldsTranslation]="dynamicFieldsTranslation"
  ></property-invoice-item>
</div>
